// import config from 'config'
// import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
// import React from 'react'
// import "./Periodicals.css"

// export const Periodicals = () => {
//   return (
//         <>
//         <RoutingMenu activeScreen="periodicals" />
//     <div className=''>

//         <iframe
//             src={`${config.RootUrl}/faculty/library/Periodicals/Periodicals.php?isIframe=true`}
//             className="iframe col-md-12"
//         >
//         </iframe>
//     </div>
//     </>
//   )
// }

import React, { Component } from 'react';
import "./Periodicals.css";
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import PeriodicalsOrJournals from 'LIBRARY/Components/Periodicals/PeriodicalsOrJournals/PeriodicalsOrJournals.js';
import DailyLogs from 'LIBRARY/Components/Periodicals/DailyLogs/DailyLogs.js';
class Periodicals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'periodicals',
      periodicalCategoryData: '',
      selectedPeriodicalIdForLog:''
    }
  }

  // METHOD TO SELECT EVENT TYPE
  selectPeriodicalType = (type) => {
    if (this.state.activeTab != type) {
      this.setState({
        activeTab: type,
        selectedPeriodicalIdForLog:''
      })
    }
  }

  // METHOD TO HANDLE categoryList
  handleCategoryList = (data) => {
    this.setState({ periodicalCategoryData: data });
  };

  // METHOD TO HANDLE DATA FROM logs
  getDailyLogDetails = (periodicalId) => {
    this.setState({ 
      activeTab: 'logs',
      selectedPeriodicalIdForLog:periodicalId
     });
  };

  render() {
    const { activeTab, periodicalCategoryData } = this.state;
    return (
      <>
        <RoutingMenu activeScreen="periodicals" />

        <div className="libraryComponents-container">
          <div className="periodicalsHeads">
            <p className={activeTab == 'periodicals' ? 'periodicalsActiveTab periodicalsSettingTab' : 'periodicalsSettingTab'} onClick={() => this.selectPeriodicalType('periodicals')}>Periodicals/ Journals</p>
            <p className={activeTab == 'logs' ? 'periodicalsActiveTab periodicalsSettingTab' : 'periodicalsSettingTab'} onClick={() => this.selectPeriodicalType('logs')}>Daily Logs</p>
          </div>
          <div className='pt-3'>
            {
              activeTab == 'periodicals' ?
                <PeriodicalsOrJournals categoryList={this.handleCategoryList} getDailyLogDetails={this.getDailyLogDetails}/>
                :
                <DailyLogs periodicalCategoryList={periodicalCategoryData} selectedPeriodicalIdForLog={this.state.selectedPeriodicalIdForLog} />
            }
          </div>
        </div>
      </>
    )
  }
}

export default Periodicals;